import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AdminAuthService } from './admin-auth.service';

export const adminTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AdminAuthService);
  const router = inject(Router);
  const token = sessionStorage.getItem('crewjam_admin_token');
  const isAdminApi = request.url.includes('/admin-api/');
  const isLogin = request.url.includes('/admin-api/auth/sessions');
  const authorizedRequest = token && isAdminApi && !isLogin
    ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : request;

  return next(authorizedRequest).pipe(catchError((error: unknown) => {
    if (error instanceof HttpErrorResponse && error.status === 401) {
      auth.clearSession();
      void router.navigate(['/unauthorized']);
    } else if (error instanceof HttpErrorResponse && error.status === 403) {
      void router.navigate(['/unauthorized']);
    }
    return throwError(() => error);
  }));
};
